import PlusIcon from "app/components/Icons/PlusIcon";
import CustomTooltip from "app/components/Tooltip";
import CustomFileUploadDropdown from "app/containers/Features/containers/Ticket/components/Content/components/Details/components/FileUploadSection/CustomFileUploadDropdown";
import React, { useRef } from "react";
import { CreateAssetResponse } from "app/components/MediaUploader/types";
import { ITicketFormData } from "../../containers/Tickets/types";
import UploadFile from "../../../Ticket/components/Content/components/Details/components/FileUploadSection/UploadFile";
import TicketAttachmentUpload from "../../../Ticket/components/TicketAttachmentUpload";
import AttachmentPreviewDialog from "../../../Ticket/components/Content/components/Details/components/FileUploadSection/components/AttachmentPreviewDialog";
import { useAddTaskAttachments } from "./hooks/useAddTaskAttachments";

interface Props {
  handleChangeFile: (data: CreateAssetResponse) => void;
  form: ITicketFormData;
}

const Attachments: React.FC<Props> = ({ handleChangeFile, form }) => {
  const fileInputRef = useRef<HTMLInputElement>(null);
  const {
    files,
    uploadingCards,
    setIsUploading,
    renamingFileId,
    renameValue,
    setRenameValue,
    submitRename,
    clearRename,
    handleAttachmentAction,
    handlePreview,
    isPreviewOpen,
    previewFile,
    closePreview,
    handlePreviewDownload,
    handlePreviewOpenFile,
    handlePreviewCopyUrl,
    handlePreviewDelete,
    handlePreviewRenameSubmit,
    onPrevious,
    onNext,
    currentItemNumber,
    totalItems,
  } = useAddTaskAttachments(form);

  return (
    <div className="flex flex-col gap-4 pb-4">
      <div className="flex flex-row justify-between items-center">
        <p className="text-xs leading-[21px] font-medium text-black">
          Attachments
        </p>
        <CustomFileUploadDropdown
          onUploadFileClick={() => fileInputRef.current?.click()}
          trigger={
            <button type="button" className="focus:outline-none">
              <CustomTooltip text="Add attachment">
                <PlusIcon size={24} color="#79808A" />
              </CustomTooltip>
            </button>
          }
        />
      </div>

      <TicketAttachmentUpload
        fileInputRef={fileInputRef}
        onUploadSuccess={handleChangeFile}
        onLoadingChange={setIsUploading}
      >
        <p className="text-xs leading-[18px] font-normal text-secondary text-center cursor-pointer">
          Drop your files here to{" "}
          <button
            type="button"
            className="underline"
            onClick={(e) => {
              e.preventDefault();
              fileInputRef.current?.click();
            }}
          >
            upload
          </button>
        </p>
      </TicketAttachmentUpload>

      <div className="flex w-full">
        <UploadFile
          files={files}
          uploadingCards={uploadingCards}
          onAction={handleAttachmentAction}
          onPreview={handlePreview}
          renamingFileId={renamingFileId}
          renameValue={renameValue}
          onRenameValueChange={setRenameValue}
          onRenameSubmit={submitRename}
          onRenameCancel={clearRename}
        />
      </div>
      <AttachmentPreviewDialog
        isOpen={isPreviewOpen}
        previewFile={previewFile}
        onClose={closePreview}
        onDownload={handlePreviewDownload}
        onOpenFile={handlePreviewOpenFile}
        onCopyUrl={handlePreviewCopyUrl}
        onDelete={handlePreviewDelete}
        onRenameSubmit={handlePreviewRenameSubmit}
        onPrevious={onPrevious}
        onNext={onNext}
        currentItemNumber={currentItemNumber}
        totalItems={totalItems}
      />
    </div>
  );
};

export default Attachments;
